/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClasseInfosForSuiviDto
 */
export interface ClasseInfosForSuiviDto {
    /**
     * 
     * @type {number}
     * @memberof ClasseInfosForSuiviDto
     */
    idmetier?: number;
}

/**
 * Check if a given object implements the ClasseInfosForSuiviDto interface.
 */
export function instanceOfClasseInfosForSuiviDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ClasseInfosForSuiviDtoFromJSON(json: any): ClasseInfosForSuiviDto {
    return ClasseInfosForSuiviDtoFromJSONTyped(json, false);
}

export function ClasseInfosForSuiviDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClasseInfosForSuiviDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idmetier': !exists(json, 'idmetier') ? undefined : json['idmetier'],
    };
}

export function ClasseInfosForSuiviDtoToJSON(value?: ClasseInfosForSuiviDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idmetier': value.idmetier,
    };
}

